export const a76e87 = [
  {
    ReverseLook: 6.8,
    Description: "Electroheat ECO-V-SV 5kW",
    "Product Code": 2780510,
    "List Price (inc)": "$3,800.00",
    Input: 1.2,
  },
  {
    ReverseLook: 9,
    Description: "Electroheat MKV 9kW",
    "Product Code": 278095,
    "List Price (inc)": "$3,003.00 ",
    Input: 1.5,
  },
  {
    ReverseLook: 11,
    Description: "Electroheat ECO-V-SV 9kW",
    "Product Code": 2780910,
    "List Price (inc)": "$4,370.00",
    Input: 1.4,
  },
  {
    ReverseLook: 12,
    Description: "Electroheat MKV - 12kW",
    "Product Code": 278123,
    "List Price (inc)": "$3,868.70 ",
    Input: 2.3,
  },
  {
    ReverseLook: 12,
    Description: "Electroheat ECO-V - 12kW",
    "Product Code": 2781210,
    "List Price (inc)": "$6,110.50 ",
    Input: 2.3,
  },
  {
    ReverseLook: 14,
    Description: "Electroheat ECO-V-SV 12kW",
    "Product Code": 2781211,
    "List Price (inc)": "$5,500.00",
    Input: 2.4,
  },
  {
    ReverseLook: 15,
    Description: "Electroheat MKV - 15kW",
    "Product Code": 278152,
    "List Price (inc)": "$4,735.50 ",
    Input: 2.1,
  },
  {
    ReverseLook: 17,
    Description: "Electoheat ECO-V - 17kW",
    "Product Code": 2781710,
    "List Price (inc)": "$7,200.00 ",
    Input: 2.8,
  },
  {
    ReverseLook: 19,
    Description: "Electroheat MKV - 19kW",
    "Product Code": 278192,
    "List Price (inc)": "$6,006.00",
    Input: 2.9,
  },
  {
    ReverseLook: 20,
    Description: "Electroheat ECO-V-SV 17kW",
    "Product Code": 2781711,
    "List Price (inc)": "$7,000.00",
    Input: 2.8,
  },
  {
    ReverseLook: 21,
    Description: "Electroheat ECO-V - 21kW",
    "Product Code": 2782110,
    "List Price (inc)": " $8,200.00 ",
    Input: 3.6,
  },
  {
    ReverseLook: 23,
    Description: "Electroheat MKV - 23kW",
    "Product Code": 278232,
    "List Price (inc)": "$7,218.75",
    Input: 3.5,
  },
  {
    ReverseLook: 25,
    Description: "Electroheat ECO-V - 25kW",
    "Product Code": 2782510,
    "List Price (inc)": "$9,900.00",
    Input: 4.4,
  },
  {
    ReverseLook: 25,
    Description: "Electroheat Plus 25 kW 3PH",
    "Product Code": 2782533,
    "List Price (inc)": "$8,373.75",
    Input: 5,
  },
  {
    ReverseLook: 26.6,
    Description: "Electroheat ECO-V-SV 25kW",
    "Product Code": 2782511,
    "List Price (inc)": "$9,360.00",
    Input: 4.4,
  },
  {
    ReverseLook: 31,
    Description: "Electroheat Plus 31 kW 3PH",
    "Product Code": 2783133,
    "List Price (inc)": "$10,048.50",
    Input: 5.6,
  },
  {
    ReverseLook: 37,
    Description: "Electroheat Plus 37 kW 3PH",
    "Product Code": 2783733,
    "List Price (inc)": "$11,550.00 ",
    Input: 6.7,
  },
  {
    ReverseLook: 37.7,
    Description: "Electroheat ECO-V 35kW 3PH",
    "Product Code": 2783510,
    "List Price (inc)": "$13,900.00",
    Input: 6,
  },
  {
    ReverseLook: 44,
    Description: "Electroheat Plus 44 kW 3PH",
    "Product Code": 2784433,
    "List Price (inc)": "$13,455.75 ",
    Input: 7.7,
  },
  {
    ReverseLook: 47.6,
    Description: "Electroheat ECO-V 45kW 3PH",
    "Product Code": 2784510,
    "List Price (inc)": "$16,990.00",
    Input: 7,
  },
];

export const c59c69 = [
  {
    "Part No": 278095,
    Description: "Electroheat MKV - 9kW",
    Capacity: 9,
    "Input Per Hour": 1.5,
  },
  {
    "Part No": 278123,
    Description: "Electroheat MKV - 12kW",
    Capacity: 12,
    "Input Per Hour": 2.3,
  },
  {
    "Part No": 2781210,
    Description: "Electroheat ECO-V - 12kW",
    Capacity: 12,
    "Input Per Hour": 2.3,
  },
  {
    "Part No": 278152,
    Description: "Electroheat MKV - 15kW",
    Capacity: 15,
    "Input Per Hour": 2.1,
  },
  {
    "Part No": 2780510,
    Description: "Electroheat ECO-V-SV 5kW",
    Capacity: 6.8,
    "Input Per Hour": 1.2,
  },
  {
    "Part No": 2780910,
    Description: "Electroheat ECO-V-SV 9kW",
    Capacity: 11,
    "Input Per Hour": 1.4,
  },
  {
    "Part No": 2781211,
    Description: "Electroheat ECO-V-SV 12kW",
    Capacity: 14,
    "Input Per Hour": 2.4,
  },
  {
    "Part No": 2781711,
    Description: "Electroheat ECO-V-SV 17kW",
    Capacity: 20,
    "Input Per Hour": 2.8,
  },
  {
    "Part No": 2782511,
    Description: "Electroheat ECO-V-SV 25kW",
    Capacity: 26.6,
    "Input Per Hour": 4.4,
  },
  {
    "Part No": 2783510,
    Description: "Electroheat ECO-V 35kW 3PH",
    Capacity: 37.7,
    "Input Per Hour": 6,
  },
  {
    "Part No": 2784510,
    Description: "Electroheat ECO-V 45kW 3PH",
    Capacity: 47.6,
    "Input Per Hour": 7,
  },
  {
    "Part No": 2781710,
    Description: "Electroheat ECO - V - 17kW",
    Capacity: 17,
    "Input Per Hour": 2.8,
  },
  {
    "Part No": 278192,
    Description: "Electroheat MKV - 19kW",
    Capacity: 19,
    "Input Per Hour": 2.9,
  },
  {
    "Part No": 2782110,
    Description: "Electroheat ECO-V - 21kW",
    Capacity: 21,
    "Input Per Hour": 3.6,
  },
  {
    "Part No": 278232,
    Description: "Electroheat MKV – 23kW",
    Capacity: 23,
    "Input Per Hour": 3.5,
  },
  {
    "Part No": 2782510,
    Description: "Electroheat ECO-V - 25kW",
    Capacity: 25,
    "Input Per Hour": 4.4,
  },
  {
    "Part No": 2782533,
    Description: "Electroheat Plus 25 kW 3PH",
    Capacity: 25,
    "Input Per Hour": 5,
  },
  {
    "Part No": 2783133,
    Description: "Electroheat Plus 31 kW 3PH",
    Capacity: 31,
    "Input Per Hour": 5.6,
  },
  {
    "Part No": 2783733,
    Description: "Electroheat Plus 37 kW 3PH",
    Capacity: 37,
    "Input Per Hour": 6.7,
  },
  {
    "Part No": 2784433,
    Description: "Electroheat Plus 44 kW 3PH",
    Capacity: 44,
    "Input Per Hour": 7.7,
  },
];

export const monthsanddates = [
  {
    Months: "Jan",
    Days: 31,
  },
  {
    Months: "Feb",
    Days: 28,
  },
  {
    Months: "Mar",
    Days: 31,
  },
  {
    Months: "Apr",
    Days: 30,
  },
  {
    Months: "May",
    Days: 31,
  },
  {
    Months: "Jun",
    Days: 30,
  },
  {
    Months: "Jul",
    Days: 31,
  },
  {
    Months: "Aug",
    Days: 31,
  },
  {
    Months: "Sep",
    Days: 30,
  },
  {
    Months: "Oct",
    Days: 31,
  },
  {
    Months: "Nov",
    Days: 30,
  },
  {
    Months: "Dec",
    Days: 31,
  },
];

export const tempbyCity = [
  {
    "1": 24,
    "2": 24,
    "3": 23,
    "4": 21,
    "5": 18.5,
    "6": 16,
    "7": 15.5,
    "8": 16,
    "9": 18,
    "10": 20,
    "11": 22,
    "12": 23,
    State: "NSW",
    City: "Ballina",
    Postcode: "2478",
  },
  {
    "1": 20.5,
    "2": 20.5,
    "3": 18,
    "4": 14,
    "5": 10.5,
    "6": 7.5,
    "7": 6.5,
    "8": 8,
    "9": 11,
    "10": 13.5,
    "11": 17,
    "12": 19,
    State: "NSW",
    City: "Bathurst",
    Postcode: "2795",
  },
  {
    "1": 22.5,
    "2": 22,
    "3": 20.7,
    "4": 18.1,
    "5": 15.2,
    "6": 13,
    "7": 12.2,
    "8": 13.1,
    "9": 15.7,
    "10": 17.7,
    "11": 19.4,
    "12": 21.1,
    State: "NSW",
    City: "Gosford",
    Postcode: "2250",
  },
  {
    "1": 18.5,
    "2": 18,
    "3": 16,
    "4": 13,
    "5": 10,
    "6": 7.5,
    "7": 7,
    "8": 8,
    "9": 10.5,
    "10": 13,
    "11": 15.5,
    "12": 17.5,
    State: "NSW",
    City: "Bowral",
    Postcode: "2576",
  },
  {
    "1": 24.5,
    "2": 24,
    "3": 23,
    "4": 21,
    "5": 18.5,
    "6": 16,
    "7": 15.5,
    "8": 16,
    "9": 18,
    "10": 20,
    "11": 22,
    "12": 23,
    State: "NSW",
    City: "Byron Bay",
    Postcode: "2481",
  },
  {
    "1": 22,
    "2": 21.5,
    "3": 20,
    "4": 17,
    "5": 14,
    "6": 11.5,
    "7": 10.5,
    "8": 12,
    "9": 14.5,
    "10": 16.5,
    "11": 19,
    "12": 21,
    State: "NSW",
    City: "Campbelltown",
    Postcode: "2560",
  },
  {
    "1": 23.5,
    "2": 23,
    "3": 21.5,
    "4": 19,
    "5": 16.5,
    "6": 14.5,
    "7": 13.5,
    "8": 14,
    "9": 17,
    "10": 19,
    "11": 20.5,
    "12": 22.5,
    State: "NSW",
    City: "Coffs Harbour",
    Postcode: "2450",
  },
  {
    "1": 25,
    "2": 24.5,
    "3": 21.5,
    "4": 17.5,
    "5": 13,
    "6": 10.5,
    "7": 9.5,
    "8": 10.5,
    "9": 13.5,
    "10": 17,
    "11": 21,
    "12": 24,
    State: "NSW",
    City: "Dubbo",
    Postcode: "2830",
  },
  {
    "1": 25,
    "2": 24,
    "3": 21,
    "4": 17,
    "5": 13,
    "6": 10,
    "7": 8.5,
    "8": 10,
    "9": 12.5,
    "10": 16,
    "11": 20,
    "12": 23,
    State: "NSW",
    City: "Forbes",
    Postcode: "2871",
  },
  {
    "1": 23,
    "2": 23,
    "3": 22,
    "4": 19,
    "5": 16.5,
    "6": 14,
    "7": 13.5,
    "8": 14,
    "9": 16,
    "10": 18.5,
    "11": 20,
    "12": 22,
    State: "NSW",
    City: "Forster",
    Postcode: "2428",
  },
  {
    "1": 20.5,
    "2": 19.5,
    "3": 17,
    "4": 13,
    "5": 9.5,
    "6": 7,
    "7": 6,
    "8": 7.5,
    "9": 10,
    "10": 13,
    "11": 16,
    "12": 18.5,
    State: "NSW",
    City: "Goulburn",
    Postcode: "2580",
  },
  {
    "1": 24,
    "2": 23.5,
    "3": 22,
    "4": 19,
    "5": 16.5,
    "6": 13.5,
    "7": 13,
    "8": 14,
    "9": 17,
    "10": 19.5,
    "11": 22,
    "12": 23,
    State: "NSW",
    City: "Grafton",
    Postcode: "2460",
  },
  {
    "1": 24.5,
    "2": 24,
    "3": 22.5,
    "4": 20.5,
    "5": 17,
    "6": 14.5,
    "7": 14,
    "8": 15,
    "9": 18,
    "10": 20,
    "11": 22,
    "12": 23.5,
    State: "NSW",
    City: "Lismore",
    Postcode: "2480",
  },
  {
    "1": 23,
    "2": 23,
    "3": 21,
    "4": 18.5,
    "5": 15.5,
    "6": 13,
    "7": 12.5,
    "8": 13.5,
    "9": 16,
    "10": 18,
    "11": 20,
    "12": 21.5,
    State: "NSW",
    City: "Newcastle",
    Postcode: "2300",
  },
  {
    "1": 21.5,
    "2": 22,
    "3": 20,
    "4": 17.5,
    "5": 15,
    "6": 13,
    "7": 12,
    "8": 13.5,
    "9": 15,
    "10": 17,
    "11": 19,
    "12": 20.5,
    State: "NSW",
    City: "Nowra",
    Postcode: "2541",
  },
  {
    "1": 23,
    "2": 22.5,
    "3": 19.5,
    "4": 16,
    "5": 12,
    "6": 9,
    "7": 8.5,
    "8": 9,
    "9": 12.5,
    "10": 15.5,
    "11": 19,
    "12": 21.5,
    State: "NSW",
    City: "Mudgee",
    Postcode: "2850",
  },
  {
    "1": 20.5,
    "2": 19.5,
    "3": 17,
    "4": 13,
    "5": 9,
    "6": 6,
    "7": 5,
    "8": 6,
    "9": 9,
    "10": 12.5,
    "11": 15.5,
    "12": 18.5,
    State: "NSW",
    City: "Orange",
    Postcode: "2800",
  },
  {
    "1": 23,
    "2": 22.5,
    "3": 21.5,
    "4": 19,
    "5": 17,
    "6": 14.5,
    "7": 13.5,
    "8": 14.5,
    "9": 16.5,
    "10": 18.5,
    "11": 20,
    "12": 22,
    State: "NSW",
    City: "Port Macquarie",
    Postcode: "2444",
  },
  {
    "1": 23,
    "2": 23,
    "3": 21.5,
    "4": 18.5,
    "5": 16,
    "6": 13.5,
    "7": 13,
    "8": 14,
    "9": 16.5,
    "10": 18.5,
    "11": 20.5,
    "12": 22.5,
    State: "NSW",
    City: "Sydney",
    Postcode: "2000",
  },
  {
    "1": 26.5,
    "2": 25.5,
    "3": 22.5,
    "4": 18,
    "5": 14,
    "6": 10.5,
    "7": 10,
    "8": 11.5,
    "9": 15,
    "10": 18.5,
    "11": 22,
    "12": 25,
    State: "NSW",
    City: "Broken Hill",
    Postcode: "2880",
  },
  {
    "1": 24.5,
    "2": 23.5,
    "3": 21.5,
    "4": 17.5,
    "5": 13.5,
    "6": 10,
    "7": 9.5,
    "8": 10.5,
    "9": 14,
    "10": 17.5,
    "11": 20.5,
    "12": 22.5,
    State: "NSW",
    City: "Tamworth",
    Postcode: "2340",
  },
  {
    "1": 23.5,
    "2": 23.5,
    "3": 21.5,
    "4": 19,
    "5": 16,
    "6": 13.5,
    "7": 12.5,
    "8": 13.5,
    "9": 16,
    "10": 18.5,
    "11": 20,
    "12": 22,
    State: "NSW",
    City: "Taree",
    Postcode: "2430",
  },
  {
    "1": 21.5,
    "2": 21.5,
    "3": 20,
    "4": 17.5,
    "5": 15,
    "6": 12.5,
    "7": 12,
    "8": 13,
    "9": 15,
    "10": 16.5,
    "11": 18.5,
    "12": 20,
    State: "NSW",
    City: "Batemans Bay",
    Postcode: "2536",
  },
  {
    "1": 20.5,
    "2": 21,
    "3": 19.5,
    "4": 17.5,
    "5": 15,
    "6": 13,
    "7": 12,
    "8": 12.5,
    "9": 14.5,
    "10": 16,
    "11": 17.5,
    "12": 19.5,
    State: "NSW",
    City: "Merimbula",
    Postcode: "2548",
  },
  {
    "1": 22.5,
    "2": 22.5,
    "3": 20.5,
    "4": 18,
    "5": 15,
    "6": 12,
    "7": 11,
    "8": 12.5,
    "9": 15.5,
    "10": 17.5,
    "11": 20,
    "12": 21.5,
    State: "NSW",
    City: "Parramatta",
    Postcode: "2150",
  },
  {
    "1": 21.5,
    "2": 21,
    "3": 19,
    "4": 16,
    "5": 12.5,
    "6": 10,
    "7": 9,
    "8": 10.5,
    "9": 13.5,
    "10": 16,
    "11": 18.5,
    "12": 20.5,
    State: "NSW",
    City: "Picton",
    Postcode: "2571",
  },
  {
    "1": 23.5,
    "2": 23,
    "3": 20.5,
    "4": 17.5,
    "5": 14,
    "6": 11.5,
    "7": 10.5,
    "8": 12,
    "9": 15,
    "10": 17.5,
    "11": 20,
    "12": 22,
    State: "NSW",
    City: "Richmond",
    Postcode: "2753",
  },
  {
    "1": 24.5,
    "2": 23.5,
    "3": 20.5,
    "4": 16,
    "5": 12,
    "6": 9,
    "7": 8.5,
    "8": 9,
    "9": 11.5,
    "10": 15,
    "11": 19.5,
    "12": 22,
    State: "NSW",
    City: "Wagga",
    Postcode: "2650",
  },
  {
    "1": 18.5,
    "2": 18.5,
    "3": 16,
    "4": 13,
    "5": 10,
    "6": 7.5,
    "7": 7,
    "8": 8,
    "9": 9.5,
    "10": 11.5,
    "11": 14,
    "12": 16.5,
    State: "VIC",
    City: "Ballarat",
    Postcode: "3350",
  },
  {
    "1": 23,
    "2": 23,
    "3": 20,
    "4": 15.5,
    "5": 12,
    "6": 9.5,
    "7": 9,
    "8": 10.5,
    "9": 12.5,
    "10": 15.5,
    "11": 18.5,
    "12": 21,
    State: "VIC",
    City: "Echuca",
    Postcode: "3564",
  },
  {
    "1": 19,
    "2": 19.5,
    "3": 17.5,
    "4": 15,
    "5": 12.5,
    "6": 10.5,
    "7": 10,
    "8": 10.5,
    "9": 12,
    "10": 13.5,
    "11": 15.5,
    "12": 17.5,
    State: "VIC",
    City: "Geelong",
    Postcode: "3220",
  },
  {
    "1": 22,
    "2": 21.5,
    "3": 19,
    "4": 15.5,
    "5": 12,
    "6": 10,
    "7": 9,
    "8": 10,
    "9": 12,
    "10": 14.5,
    "11": 17.5,
    "12": 20,
    State: "VIC",
    City: "Horsham",
    Postcode: "3400",
  },
  {
    "1": 19.5,
    "2": 19.5,
    "3": 18,
    "4": 15,
    "5": 12.5,
    "6": 10,
    "7": 9.5,
    "8": 10.5,
    "9": 12,
    "10": 14,
    "11": 16,
    "12": 18,
    State: "VIC",
    City: "Melbourne",
    Postcode: "3000",
  },
  {
    "1": 26,
    "2": 26,
    "3": 22.5,
    "4": 18.5,
    "5": 14,
    "6": 11.5,
    "7": 10.5,
    "8": 12,
    "9": 15,
    "10": 18.5,
    "11": 22,
    "12": 24.5,
    State: "VIC",
    City: "Mildura",
    Postcode: "3500",
  },
  {
    "1": 23,
    "2": 22.5,
    "3": 19.5,
    "4": 15,
    "5": 11.5,
    "6": 9,
    "7": 8.5,
    "8": 9.5,
    "9": 12,
    "10": 14.5,
    "11": 17.5,
    "12": 20.5,
    State: "VIC",
    City: "Shepparton",
    Postcode: "3630",
  },
  {
    "1": 19,
    "2": 19.5,
    "3": 17.5,
    "4": 14,
    "5": 11.5,
    "6": 9.5,
    "7": 8.5,
    "8": 10,
    "9": 11.5,
    "10": 13,
    "11": 15.5,
    "12": 17.5,
    State: "VIC",
    City: "Traralgon",
    Postcode: "3844",
  },
  {
    "1": 24,
    "2": 23.5,
    "3": 20.5,
    "4": 15.5,
    "5": 11.5,
    "6": 8.5,
    "7": 8,
    "8": 9,
    "9": 11.5,
    "10": 15,
    "11": 18.5,
    "12": 21.5,
    State: "VIC",
    City: "Wodonga",
    Postcode: "3690",
  },
  {
    "1": 17.5,
    "2": 17.5,
    "3": 17,
    "4": 15,
    "5": 13,
    "6": 11.5,
    "7": 11,
    "8": 11.5,
    "9": 12.5,
    "10": 13,
    "11": 15,
    "12": 16,
    State: "VIC",
    City: "Warrnambool",
    Postcode: "3280",
  },
  {
    "1": 21.5,
    "2": 21.5,
    "3": 18.5,
    "4": 15,
    "5": 11,
    "6": 9,
    "7": 8,
    "8": 9.5,
    "9": 11.5,
    "10": 13.5,
    "11": 17,
    "12": 19.5,
    State: "VIC",
    City: "Bendigo",
    Postcode: "3550",
  },
  {
    "1": 19.5,
    "2": 19.5,
    "3": 17.5,
    "4": 15,
    "5": 12,
    "6": 10,
    "7": 9.5,
    "8": 10.5,
    "9": 12,
    "10": 13.5,
    "11": 16,
    "12": 18,
    State: "VIC",
    City: "Bairnsdale",
    Postcode: "3875",
  },
  {
    "1": 22,
    "2": 22,
    "3": 18.5,
    "4": 14.5,
    "5": 10.5,
    "6": 8.5,
    "7": 8,
    "8": 9,
    "9": 11,
    "10": 13.5,
    "11": 17,
    "12": 20,
    State: "VIC",
    City: "Benalla",
    Postcode: "3672",
  },
  {
    "1": 18,
    "2": 18,
    "3": 17,
    "4": 15,
    "5": 13,
    "6": 11,
    "7": 11,
    "8": 11.5,
    "9": 12.5,
    "10": 13.5,
    "11": 15,
    "12": 17,
    State: "VIC",
    City: "Cowes",
    Postcode: "3922",
  },
  {
    "1": 19,
    "2": 19,
    "3": 17.5,
    "4": 14,
    "5": 11,
    "6": 9.5,
    "7": 8.5,
    "8": 10,
    "9": 11.5,
    "10": 13,
    "11": 15,
    "12": 17.5,
    State: "VIC",
    City: "Morwell",
    Postcode: "3840",
  },
  {
    "1": 17,
    "2": 17,
    "3": 16.5,
    "4": 14.5,
    "5": 13,
    "6": 12,
    "7": 11,
    "8": 11.5,
    "9": 12.5,
    "10": 13.5,
    "11": 14.5,
    "12": 15.5,
    State: "VIC",
    City: "Portland",
    Postcode: "3305",
  },
  {
    "1": 20.5,
    "2": 20.5,
    "3": 18,
    "4": 14,
    "5": 11,
    "6": 9,
    "7": 8.5,
    "8": 9,
    "9": 11.5,
    "10": 13,
    "11": 16,
    "12": 18.5,
    State: "VIC",
    City: "Stawell",
    Postcode: "3380",
  },
  {
    "1": 25,
    "2": 25,
    "3": 21.5,
    "4": 16.5,
    "5": 13.5,
    "6": 10.5,
    "7": 10,
    "8": 11,
    "9": 13.5,
    "10": 16.5,
    "11": 20.5,
    "12": 23,
    State: "VIC",
    City: "Swan Hill",
    Postcode: "3585",
  },
  {
    "1": 17.5,
    "2": 18,
    "3": 17,
    "4": 14.5,
    "5": 12.5,
    "6": 11,
    "7": 10.5,
    "8": 11,
    "9": 12.5,
    "10": 13,
    "11": 15,
    "12": 16,
    State: "VIC",
    City: "Wonthaggi",
    Postcode: "3995",
  },
  {
    "1": 25,
    "2": 24.5,
    "3": 23,
    "4": 21,
    "5": 18.5,
    "6": 16,
    "7": 15,
    "8": 15.5,
    "9": 18.5,
    "10": 20.5,
    "11": 22.5,
    "12": 24,
    State: "QLD",
    City: "Brisbane",
    Postcode: "4000",
  },
  {
    "1": 26.5,
    "2": 26.5,
    "3": 25.5,
    "4": 23.5,
    "5": 21,
    "6": 18.5,
    "7": 17.5,
    "8": 18.5,
    "9": 21,
    "10": 23,
    "11": 24.5,
    "12": 26,
    State: "QLD",
    City: "Bundaberg",
    Postcode: "4670",
  },
  {
    "1": 27.5,
    "2": 27.5,
    "3": 26.5,
    "4": 25.5,
    "5": 23.5,
    "6": 22.5,
    "7": 21.5,
    "8": 22,
    "9": 23.5,
    "10": 25,
    "11": 26.5,
    "12": 27.5,
    State: "QLD",
    City: "Cairns",
    Postcode: "4870",
  },
  {
    "1": 27,
    "2": 27,
    "3": 25.5,
    "4": 23.5,
    "5": 20,
    "6": 17.5,
    "7": 17,
    "8": 18,
    "9": 21,
    "10": 23.5,
    "11": 25,
    "12": 26.5,
    State: "QLD",
    City: "Rockhampton",
    Postcode: "4700",
  },
  {
    "1": 28,
    "2": 28,
    "3": 27,
    "4": 25,
    "5": 23,
    "6": 20.5,
    "7": 20,
    "8": 20.5,
    "9": 23,
    "10": 25.5,
    "11": 27,
    "12": 28,
    State: "QLD",
    City: "Townsville",
    Postcode: "4810",
  },
  {
    "1": 22.5,
    "2": 21.5,
    "3": 20,
    "4": 17,
    "5": 13.5,
    "6": 10.5,
    "7": 9,
    "8": 10.5,
    "9": 14.5,
    "10": 17.5,
    "11": 20,
    "12": 21.5,
    State: "QLD",
    City: "Toowoomba",
    Postcode: "4350",
  },
  {
    "1": 27.5,
    "2": 26.5,
    "3": 25.5,
    "4": 24,
    "5": 21.5,
    "6": 19,
    "7": 18.5,
    "8": 20,
    "9": 22,
    "10": 24,
    "11": 25.5,
    "12": 26.5,
    State: "QLD",
    City: "Gladstone",
    Postcode: "4680",
  },
  {
    "1": 24.5,
    "2": 24.5,
    "3": 23.5,
    "4": 21,
    "5": 19,
    "6": 16.5,
    "7": 15.5,
    "8": 16,
    "9": 18.5,
    "10": 20,
    "11": 22.5,
    "12": 23.5,
    State: "QLD",
    City: "Gold Coast",
    Postcode: "4217",
  },
  {
    "1": 25,
    "2": 24.5,
    "3": 23,
    "4": 20.5,
    "5": 17.5,
    "6": 14.5,
    "7": 14,
    "8": 15.5,
    "9": 18,
    "10": 20.5,
    "11": 23,
    "12": 24.5,
    State: "QLD",
    City: "Gympie",
    Postcode: "4570",
  },
  {
    "1": 27,
    "2": 26.5,
    "3": 25.5,
    "4": 23.5,
    "5": 21,
    "6": 18,
    "7": 17.5,
    "8": 18.5,
    "9": 21,
    "10": 23.5,
    "11": 25.5,
    "12": 27,
    State: "QLD",
    City: "Mackay",
    Postcode: "4740",
  },
  {
    "1": 25,
    "2": 25,
    "3": 23.5,
    "4": 21.5,
    "5": 19,
    "6": 16.5,
    "7": 15.5,
    "8": 16,
    "9": 18.5,
    "10": 21,
    "11": 22.5,
    "12": 24,
    State: "QLD",
    City: "Noosa Heads",
    Postcode: "4567",
  },
  {
    "1": 23,
    "2": 23,
    "3": 21,
    "4": 17.5,
    "5": 14,
    "6": 11.5,
    "7": 10,
    "8": 11.5,
    "9": 15.5,
    "10": 18,
    "11": 20.5,
    "12": 22,
    State: "QLD",
    City: "Warwick",
    Postcode: "4370",
  },
  {
    "1": -1.5,
    "2": -0.5,
    "3": 4,
    "4": 10,
    "5": 16,
    "6": 21,
    "7": 23.5,
    "8": 22.5,
    "9": 19,
    "10": 13.5,
    "11": 7.5,
    "12": 2,
    State: "QLD",
    City: "Cleveland",
    Postcode: "4163",
  },
  {
    "1": 22.5,
    "2": 22.5,
    "3": 20,
    "4": 17,
    "5": 14,
    "6": 11.5,
    "7": 11.5,
    "8": 12,
    "9": 14,
    "10": 16.5,
    "11": 19,
    "12": 20.5,
    State: "SA",
    City: "Adelaide",
    Postcode: "5000",
  },
  {
    "1": 18,
    "2": 18.5,
    "3": 17,
    "4": 14.5,
    "5": 12.5,
    "6": 10.5,
    "7": 10,
    "8": 10.5,
    "9": 11.5,
    "10": 13,
    "11": 15,
    "12": 16.5,
    State: "SA",
    City: "Mount Gambier",
    Postcode: "5290",
  },
  {
    "1": 21,
    "2": 21,
    "3": 18,
    "4": 14.5,
    "5": 11.5,
    "6": 9,
    "7": 9,
    "8": 9.5,
    "9": 11.5,
    "10": 14,
    "11": 17,
    "12": 19,
    State: "SA",
    City: "Mount Barker",
    Postcode: "5251",
  },
  {
    "1": 21,
    "2": 20.5,
    "3": 19,
    "4": 16,
    "5": 14.5,
    "6": 12.5,
    "7": 12,
    "8": 12,
    "9": 14,
    "10": 16,
    "11": 18,
    "12": 19.5,
    State: "SA",
    City: "Victor Harbor",
    Postcode: "5211",
  },
  {
    "1": 23.5,
    "2": 23.5,
    "3": 21,
    "4": 17.5,
    "5": 14,
    "6": 12,
    "7": 11,
    "8": 12.5,
    "9": 15,
    "10": 17.5,
    "11": 20.5,
    "12": 22.5,
    State: "SA",
    City: "Whyalla",
    Postcode: "5600",
  },
  {
    "1": 25,
    "2": 25,
    "3": 22,
    "4": 17.5,
    "5": 13.5,
    "6": 11,
    "7": 10.5,
    "8": 12,
    "9": 14.5,
    "10": 17.5,
    "11": 21.5,
    "12": 23.5,
    State: "SA",
    City: "Loxton",
    Postcode: "5333",
  },
  {
    "1": 22,
    "2": 22,
    "3": 18.5,
    "4": 15,
    "5": 11.5,
    "6": 8.5,
    "7": 8,
    "8": 9,
    "9": 12,
    "10": 14.5,
    "11": 18,
    "12": 20,
    State: "SA",
    City: "Clare",
    Postcode: "5453",
  },
  {
    "1": 20,
    "2": 20,
    "3": 19,
    "4": 16.5,
    "5": 15,
    "6": 12.5,
    "7": 11.5,
    "8": 12,
    "9": 12.5,
    "10": 15,
    "11": 17,
    "12": 18.5,
    State: "SA",
    City: "Port Lincoln",
    Postcode: "5606",
  },
  {
    "1": 24.5,
    "2": 24.5,
    "3": 22,
    "4": 18,
    "5": 14.5,
    "6": 12,
    "7": 11,
    "8": 12,
    "9": 15,
    "10": 17.5,
    "11": 20.5,
    "12": 22.5,
    State: "SA",
    City: "Port Pirie",
    Postcode: "5540",
  },
  {
    "1": 22.5,
    "2": 22.5,
    "3": 19.5,
    "4": 16,
    "5": 12,
    "6": 9.5,
    "7": 8.5,
    "8": 10,
    "9": 12.5,
    "10": 15.5,
    "11": 18.5,
    "12": 21,
    State: "SA",
    City: "Tanunda",
    Postcode: "5352",
  },
  {
    "1": 28.5,
    "2": 27.5,
    "3": 25,
    "4": 20.5,
    "5": 16,
    "6": 12,
    "7": 12.5,
    "8": 15,
    "9": 19.5,
    "10": 23,
    "11": 26,
    "12": 28,
    State: "NT",
    City: "Alice Springs",
    Postcode: "0870",
  },
  {
    "1": 28.5,
    "2": 28.5,
    "3": 28.5,
    "4": 28,
    "5": 27.5,
    "6": 26,
    "7": 25,
    "8": 26,
    "9": 28,
    "10": 29,
    "11": 29.5,
    "12": 29,
    State: "NT",
    City: "Darwin",
    Postcode: "0800",
  },
  {
    "1": 18.5,
    "2": 19,
    "3": 18.5,
    "4": 16.5,
    "5": 14.5,
    "6": 13,
    "7": 12,
    "8": 12.5,
    "9": 13.5,
    "10": 14.5,
    "11": 15.5,
    "12": 17.5,
    State: "WA",
    City: "Albany",
    Postcode: "6330",
  },
  {
    "1": 30,
    "2": 29.5,
    "3": 29.5,
    "4": 28.5,
    "5": 25,
    "6": 22.5,
    "7": 22,
    "8": 23,
    "9": 25.5,
    "10": 28,
    "11": 29.5,
    "12": 30,
    State: "WA",
    City: "Broome",
    Postcode: "6725",
  },
  {
    "1": 21.5,
    "2": 22.5,
    "3": 21,
    "4": 18.5,
    "5": 16,
    "6": 14,
    "7": 13,
    "8": 13.5,
    "9": 13.5,
    "10": 15,
    "11": 17.5,
    "12": 20,
    State: "WA",
    City: "Busselton",
    Postcode: "6280",
  },
  {
    "1": 21,
    "2": 21.5,
    "3": 20.5,
    "4": 19,
    "5": 16.5,
    "6": 14.5,
    "7": 13.5,
    "8": 14,
    "9": 15,
    "10": 16.5,
    "11": 18.5,
    "12": 19.5,
    State: "WA",
    City: "Esperance",
    Postcode: "6450",
  },
  {
    "1": 31,
    "2": 31,
    "3": 31,
    "4": 29,
    "5": 25.5,
    "6": 22,
    "7": 21.5,
    "8": 23,
    "9": 25,
    "10": 28,
    "11": 29,
    "12": 30.5,
    State: "WA",
    City: "Karratha",
    Postcode: "6714",
  },
  {
    "1": 23,
    "2": 23,
    "3": 21.5,
    "4": 18.5,
    "5": 15.5,
    "6": 14,
    "7": 13,
    "8": 13,
    "9": 14,
    "10": 16,
    "11": 18.5,
    "12": 21,
    State: "WA",
    City: "Mandurah",
    Postcode: "6210",
  },
  {
    "1": 20.5,
    "2": 21,
    "3": 20.5,
    "4": 18.5,
    "5": 16.5,
    "6": 15,
    "7": 14,
    "8": 14,
    "9": 14,
    "10": 15,
    "11": 17,
    "12": 18.5,
    State: "WA",
    City: "Margaret River",
    Postcode: "6285",
  },
  {
    "1": 24,
    "2": 25,
    "3": 24,
    "4": 22,
    "5": 18.5,
    "6": 16.5,
    "7": 15,
    "8": 15.5,
    "9": 16,
    "10": 18,
    "11": 20.5,
    "12": 22.5,
    State: "WA",
    City: "Geraldton",
    Postcode: "6530",
  },
  {
    "1": 24.5,
    "2": 25,
    "3": 23.5,
    "4": 20,
    "5": 17.5,
    "6": 15,
    "7": 14,
    "8": 14.5,
    "9": 15.5,
    "10": 18,
    "11": 20.5,
    "12": 22.5,
    State: "WA",
    City: "Perth",
    Postcode: "6000",
  },
  {
    "1": 16.5,
    "2": 17,
    "3": 15.5,
    "4": 13,
    "5": 10.5,
    "6": 9,
    "7": 8.5,
    "8": 9.5,
    "9": 11,
    "10": 12,
    "11": 14,
    "12": 15.5,
    State: "TAS",
    City: "Hobart",
    Postcode: "7000",
  },
  {
    "1": 17.5,
    "2": 17.5,
    "3": 16,
    "4": 13.5,
    "5": 10,
    "6": 8.5,
    "7": 7.5,
    "8": 8.5,
    "9": 10,
    "10": 11.5,
    "11": 14,
    "12": 16,
    State: "TAS",
    City: "Launceston",
    Postcode: "7250",
  },
  {
    "1": 16,
    "2": 16.5,
    "3": 15.5,
    "4": 14,
    "5": 12,
    "6": 10.5,
    "7": 9.5,
    "8": 10.5,
    "9": 11.5,
    "10": 12,
    "11": 14,
    "12": 15,
    State: "TAS",
    City: "Burnie",
    Postcode: "7320",
  },
  {
    "1": 16.5,
    "2": 16.5,
    "3": 15.5,
    "4": 14,
    "5": 12,
    "6": 10.5,
    "7": 9.5,
    "8": 10,
    "9": 11,
    "10": 12,
    "11": 13.5,
    "12": 15,
    State: "TAS",
    City: "Ulverstone",
    Postcode: "7315",
  },
  {
    "1": 21,
    "2": 20.5,
    "3": 17.5,
    "4": 13.5,
    "5": 9.5,
    "6": 7,
    "7": 6,
    "8": 7.5,
    "9": 10,
    "10": 13,
    "11": 16.5,
    "12": 19.5,
    State: "ACT",
    City: "Canberra",
    Postcode: "2600",
  },
  {
    "1": 20,
    "2": 20,
    "3": 18.5,
    "4": 16,
    "5": 14,
    "6": 12,
    "7": 11.5,
    "8": 12,
    "9": 13,
    "10": 14.5,
    "11": 16,
    "12": 18,
    State: "NZ",
    City: "Auckland",
    Postcode: "1010",
  },
  {
    "1": 18.5,
    "2": 18,
    "3": 17,
    "4": 14,
    "5": 11.5,
    "6": 9,
    "7": 8.5,
    "8": 9.5,
    "9": 11.5,
    "10": 13,
    "11": 15,
    "12": 17,
    State: "NZ",
    City: "Blenheim",
    Postcode: "7201",
  },
  {
    "1": 14,
    "2": 14,
    "3": 13,
    "4": 11,
    "5": 9.5,
    "6": 7,
    "7": 6.5,
    "8": 7.5,
    "9": 9,
    "10": 10.5,
    "11": 11.5,
    "12": 13,
    State: "NZ",
    City: "Bluff",
    Postcode: "9814",
  },
  {
    "1": 17,
    "2": 17,
    "3": 15,
    "4": 12.5,
    "5": 10,
    "6": 7,
    "7": 7,
    "8": 8,
    "9": 10,
    "10": 11.5,
    "11": 13.5,
    "12": 15.5,
    State: "NZ",
    City: "Christchurch",
    Postcode: "8011",
  },
  {
    "1": 14.5,
    "2": 14.5,
    "3": 13,
    "4": 11,
    "5": 8.5,
    "6": 6.5,
    "7": 6,
    "8": 7.5,
    "9": 9,
    "10": 10,
    "11": 11.5,
    "12": 13,
    State: "NZ",
    City: "Dunedin",
    Postcode: "9016",
  },
  {
    "1": 16,
    "2": 16,
    "3": 15,
    "4": 13,
    "5": 11.5,
    "6": 9.5,
    "7": 9,
    "8": 9.5,
    "9": 11,
    "10": 12,
    "11": 13,
    "12": 15,
    State: "NZ",
    City: "Greymouth",
    Postcode: "7805",
  },
  {
    "1": 19.5,
    "2": 19.5,
    "3": 17.5,
    "4": 15.5,
    "5": 13,
    "6": 10.5,
    "7": 10,
    "8": 10.5,
    "9": 12,
    "10": 14,
    "11": 15.5,
    "12": 17.5,
    State: "NZ",
    City: "Hamilton",
    Postcode: "3204",
  },
  {
    "1": 20,
    "2": 20.5,
    "3": 19.5,
    "4": 17.5,
    "5": 16,
    "6": 14,
    "7": 13,
    "8": 13,
    "9": 14,
    "10": 15,
    "11": 16.5,
    "12": 18.5,
    State: "NZ",
    City: "Kerikeri",
    Postcode: "0230",
  },
  {
    "1": 19.5,
    "2": 19.5,
    "3": 17.5,
    "4": 15,
    "5": 13,
    "6": 10.5,
    "7": 10.5,
    "8": 11,
    "9": 12.5,
    "10": 14.5,
    "11": 16.5,
    "12": 18.5,
    State: "NZ",
    City: "Napier",
    Postcode: "4110",
  },
  {
    "1": 17.5,
    "2": 18,
    "3": 16.5,
    "4": 14,
    "5": 11.5,
    "6": 8.5,
    "7": 8,
    "8": 9.5,
    "9": 10.5,
    "10": 12.5,
    "11": 14.5,
    "12": 16.5,
    State: "NZ",
    City: "Nelson",
    Postcode: "7010",
  },
  {
    "1": 18.5,
    "2": 18.5,
    "3": 16.5,
    "4": 14,
    "5": 12,
    "6": 10,
    "7": 9,
    "8": 9.5,
    "9": 11.5,
    "10": 13,
    "11": 14.5,
    "12": 17,
    State: "NZ",
    City: "Palmerston North",
    Postcode: "4410",
  },
  {
    "1": 13.5,
    "2": 13.5,
    "3": 11.5,
    "4": 9,
    "5": 5.5,
    "6": 3,
    "7": 2.5,
    "8": 4.5,
    "9": 6.5,
    "10": 8.5,
    "11": 10.5,
    "12": 12.5,
    State: "NZ",
    City: "Queenstown",
    Postcode: "9300",
  },
  {
    "1": 18,
    "2": 18,
    "3": 16,
    "4": 13.5,
    "5": 11,
    "6": 8.5,
    "7": 7.5,
    "8": 8.5,
    "9": 10,
    "10": 12,
    "11": 14.5,
    "12": 16.5,
    State: "NZ",
    City: "Rotorua",
    Postcode: "3010",
  },
  {
    "1": 19.5,
    "2": 19.5,
    "3": 18,
    "4": 16,
    "5": 13.5,
    "6": 11.5,
    "7": 10.5,
    "8": 11.5,
    "9": 12.5,
    "10": 14.5,
    "11": 15.5,
    "12": 17.5,
    State: "NZ",
    City: "Tauranga",
    Postcode: "3110",
  },
  {
    "1": 17.5,
    "2": 17.5,
    "3": 16,
    "4": 14,
    "5": 12,
    "6": 10,
    "7": 9.5,
    "8": 10,
    "9": 11.5,
    "10": 12.5,
    "11": 14,
    "12": 15.5,
    State: "NZ",
    City: "Wellington",
    Postcode: "6011",
  },
  {
    "1": 20,
    "2": 21,
    "3": 19.5,
    "4": 17.5,
    "5": 15.5,
    "6": 14,
    "7": 13,
    "8": 13,
    "9": 13.5,
    "10": 15,
    "11": 17,
    "12": 19,
    State: "NZ",
    City: "Whangarei",
    Postcode: "0110",
  },
];
